module.exports = {"id":"233282","name":"Yoon Bo Sang","rating":"74","photo":"./data/images/photos/2/233282.png","club":{"name":"GwangJu FC","logo":"./data/images/clubs/GwangJuFC.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoonBoSang0.json
// module id = 4423
// module chunks = 0